import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsa_unidade } from "../../services/api";

import './detalhamento_bolsa.css';

const Bolsa_unidade = (props) => {

    const [data2, setData2] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolsa_unidade(data_inicio, data_fim, cod_unidade);
            console.log("response BU", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    let chartBolUni = [];

    if (typeof data2 !== 'undefined') {
        const total = data2.reduce((acumulador, item) => {
            return acumulador + parseInt(item.alunos);
        }, 0);

        chartBolUni = data2.map((item, index) => {
            const row = [item.bolsas];
            row.push(item.alunos || 0);
            row.push((100 * parseInt(item.alunos)) / total);
            row.push(item.bolsa_media + ' %')
            return row;
        });
    };

    chartBolUni.unshift(["BOLSAS", "ALUNOS", "DISTRIBUIÇÃO %", "VLR MÉDIO"]);

    console.log("chartBolUni", chartBolUni)

    const options = {
        allowHtml: true,

    };

    const formatters = [
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "BarFormat",
            column: 2,
            options: {
                width: 120,
                base: 0,
                max: 100,
                min: 0,
            },
        },
    ];

    return (
        <div className="Bolsas">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartBolUni}
                options={options}
                formatters={formatters}

            />
        </div>
    );
};
export default Bolsa_unidade;